import { createAction } from '@reduxjs/toolkit';
import { INITIAL_PRIVACY_CONSENT, SET_IS_PRIVACY_CONSENT_TOUCHED, SET_PRIVACY_CONSENT, } from './actionTypes';
export const setIsPrivacyConsent = createAction(SET_PRIVACY_CONSENT);
export const initialPrivacyConsent = createAction(INITIAL_PRIVACY_CONSENT);
export const setIsPrivacyConsentTouched = createAction(SET_IS_PRIVACY_CONSENT_TOUCHED);
